// S12 Platform settings, one tab per URL (M11). Platform admins only.
import { createFileRoute, notFound } from '@tanstack/react-router';
import { AdminLayout, isPlatformTab } from '@/features/admin/platform/AdminLayout';
import { PlatformTab } from '@/features/admin/platform/PlatformTab';
import { requireStaffSession } from '@/lib/session';

export const Route = createFileRoute('/admin/$tab')({
  beforeLoad: async ({ context, location, params }) => {
    await requireStaffSession(context.queryClient, location.href);
    if (!isPlatformTab(params.tab)) {
      throw notFound();
    }
  },
  component: AdminTabPage,
});

function AdminTabPage() {
  const { tab } = Route.useParams();
  if (!isPlatformTab(tab)) {
    return null;
  }
  return (
    <AdminLayout active={tab}>
      <PlatformTab tab={tab} />
    </AdminLayout>
  );
}
